// FOR LOCALHOST (COMMENT BEFORE DEPLOY!)
import { reactive } from 'vue';
// const baseUrl = 'http://localhost:8487';

// FOR TEST SERVER (UNCOMMENT BEFORE DEPLOY!)
const baseUrl = 'https://olan-api.desi9n.pl';

// FOR PROD SERVER (UNCOMMENT BEFORE DEPLOY!)
// const baseUrl = 'XXXhttps://api.olanpoludnie.plYYY';

const authStore = {
    data: reactive({
        isAuthenticated: false,
        menuCategories: []
    })
}

export {baseUrl, authStore};
